import z from 'zod';
import type { SubRoutes } from './routes';

export const mascaradeRoutes = {
  '/mascarade/:userId': {
    params: {
      userId: z.guid()
    },
    post: {
      response: z.undefined(),
      permissions: ['manageMascarade']
    }
  },
  '/mascarade': {
    params: undefined,
    post: {
      response: z.object({
        userId: z.string().nullable()
      }),
      permissions: 'NONE'
    }
  }
} as const satisfies SubRoutes<'/mascarade'>;
